<ng-container *ngIf="hide_small; else noDrawer">
  <mat-drawer-container hasBackdrop="true" class="example-container">
    <mat-drawer #drawer mode="over">
      <app-overview-filter-menu (inputValuesChange)="onInputValuesChange($event)" (closeDrawer)="closeDrawer()"></app-overview-filter-menu>
    </mat-drawer>
    <mat-drawer-content>
      <main>
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </main>
    </mat-drawer-content>
  </mat-drawer-container>
</ng-container>

<ng-template #noDrawer>
  <main>
    <app-overview-filter-menu (inputValuesChange)="onInputValuesChange($event)"></app-overview-filter-menu>
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </main>
</ng-template>

<ng-template #content>
  <div class="content">
    <div class="top-row" *ngIf="hide_small">
      <h1 class="event-count">Activiteiten</h1>
      <div id="filter-button-container">
        <button class="filter-button" mat-raised-button (click)="drawer.toggle()">
          <i class="bi bi-sliders me-1"></i> Filter activiteiten
        </button>
      </div>
    </div>

    <ng-container *ngIf="!loadingEvents; else placeHolder">
      <div class="d-grid card-holder" *ngIf="getFilteredEvents().length > 0; else noEvents">
        <app-event-card *ngFor='let event of getFilteredEvents()' [event]="event" [border]="true"></app-event-card>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #noEvents>
  <div class="no-results">
    <h2>Geen resultaten gevonden</h2>
    <b>We hebben helaas geen resultaten gevonden met je huidige filterinstellingen. Pas je filterinstellingen aan, of zoek met een andere term.</b>
    <br><br>
    <h3>Wat nu?</h3>
    <ul>
      <li>Probeer andere filterinstellingen.</li>
      <li>Gebruik een andere zoekterm, indien je die hebt gebruikt.</li>
      <li>Stel je vraag aan ons! Wij helpen je graag verder.</li>
    </ul>
    <p>Als je hier een resultaat had verwacht en zeker weet dat je de correcte filterinstellingen hebt ingevuld, neem dan gerust contact met ons op en wellicht kunnen we je verder helpen!</p>
  </div>
</ng-template>

<ng-template #placeHolder>
  <div class="d-grid card-holder">
    <ng-container *ngFor="let _ of [].constructor(hide_small ? 6 : 12)">
      <app-event-card-placeholder [border]="true"></app-event-card-placeholder>
    </ng-container>
  </div>
</ng-template>
